<template>
    <v-app  id="inspire">
        <v-main  id="landing-page">
            <v-container fluid fill-height>
                <v-layout align-center justify-center >
                    <v-flex xs8 sm5 md4 lg3 xl2 >
                        <div >
                            <div class="text-center" >
                                <img src="@/assets/logo_login.png"  >
                            </div>
                            <div class="text-center" >
                                <p class="text-body-1">Resetar Senha</p>
                            </div>
                            <br>
                            <v-alert v-if="message!=''" text  close-icon="mdi-delete" dismissible :color="color"  >
                                {{ message }}
                            </v-alert>
                        </div>
                        <ValidationObserver ref="observer" v-slot="{ passes }">
                            <div>
                                <v-form >
                                    <ValidationProvider  rules="required|email" v-slot="{ errors }" name="Email" ref="myinput">
                                        <v-text-field
                                                name="password_old"
                                                :error-messages="errors"
                                                label="Email"
                                                type="email"
                                                v-model.trim="email"
                                                autofocus
                                                solo prepend-inner-icon="mdi-email"
                                        ></v-text-field>
                                    </ValidationProvider>
                                    <ValidationProvider rules="required|digits_between:6" vid="password" v-slot="{ errors }" name='password'>
                                        <v-text-field
                                                name="password"
                                                :error-messages="errors"
                                                type="password"
                                                label="Nova Senha"
                                                solo
                                                prepend-inner-icon="mdi-key"
                                                v-model.trim="password"
                                        ></v-text-field>
                                    </ValidationProvider>
                                    <ValidationProvider rules="required|confirmed:password" v-slot="{ errors }" name='PasswordConfirmation'>
                                        <v-text-field
                                                name="PasswordConfirmation"
                                                :error-messages="errors"
                                                type="password"
                                                label="Confirme a Senha"
                                                solo
                                                prepend-inner-icon="mdi-key"
                                                @keyup.enter="passes(checkPassword)"
                                                v-model.trim="password_confirmation"
                                        ></v-text-field>
                                    </ValidationProvider>
                                </v-form>
                            </div>
                            <br>
                            <div class="text-center" >
                                <v-btn outlined  to="/" class="mr-xs-1 mr-sm-10" color="primary">Login</v-btn>
                                <v-btn   @click="passes(updateForgottenPassword)" color="primary">Resetar</v-btn>
                            </div>
                        </ValidationObserver>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import AuthService from '@/services/auth-service'
    export default {
        name: "ResetPassword",
        components: {
            ValidationObserver,
            ValidationProvider
        },
        data () {
            return {
                email: '',
                password: '',
                password_confirmation: '',
                token: '',
                message: '',
                color: 'red',
                active1: true
            }
        },
        methods: {
            updateForgottenPassword () {
                AuthService.updateForgottenPassword({input: {
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                        token: this.token
                    }}).then((data) =>{
                    this.active1 = true
                    this.color = 'red'
                    this.message = data
                    if (data === 'Sua senha foi redefinida!') {
                        this.color = 'green'
                    }
                    this.$toasted.global.defaultSuccess();
                    this.$router.push('/');
                }).catch((erro) => {
                    console.error(erro)
                    this.active1 = true
                    this.message = 'Erro na Operação!'
                })
            }
        },
        destroyed() {
            let elHtml = document.getElementsByTagName('html')[0]
            elHtml.style.overflowY = null
        },
        mounted () {
            let elHtml = document.getElementsByTagName('html')[0]
            elHtml.style.overflowY = 'auto'
            this.email = this.$route.query.email
            this.token = this.$route.params.token
        }
    }
</script>

<style scoped>
    #landing-page {
        background-image: url('../../assets/images/login-bg.jpg');
        height: 100vh;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    img {
        width: 100%;
    }

</style>